import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OhlcData {
  time: string;
  ohlc: number[];
}

const liveSentiment = createSlice({
  name: 'liveSentimentData',
  initialState: {
    chartsArray: {}
  },
  reducers: {
    setLiveSentiment: (state:any, action: PayloadAction<OhlcData>) => {
      // Update the state with the new OHLC data
      const { time, ohlc } = action.payload;
      state.chartsArray[time] = ohlc;
    },
    updateCurrentCandle: (state:any, action: PayloadAction<OhlcData>) => {
        const { time, ohlc } = action.payload; // time is the key like '09:30:00' and ohlc is the new data
        state.chartsArray[time] = ohlc; // Update only the current minute's candle
    
}
}
});

export const { setLiveSentiment, updateCurrentCandle } = liveSentiment.actions;
export default liveSentiment.reducer;